import Hammer from 'hammerjs'

let hammerManager = false
let hammerSwipe = new Hammer.Swipe()


const onStageSwipe = (e) => {
  let trigger = false
  switch(e.offsetDirection) {
    case Hammer.DIRECTION_LEFT:
      trigger = document.querySelector('a.randomize')
      break;
    case Hammer.DIRECTION_RIGHT:
      trigger = document.querySelector('a.brand')
      break;
    case Hammer.DIRECTION_UP:
      // trigger = document.querySelector('a.about-header-link')
      break;
    case Hammer.DIRECTION_DOWN:
      // trigger = document.querySelector('a.workcard-header-link')
      break;
  }
  if (trigger) {
    trigger.click()
  }
}


export const initSwipeEvents = (el) => {
  if (hammerManager) {
    hammerManager.destroy()
  }
  if (el) {
    hammerManager = new Hammer.Manager(el)
    hammerManager.add(hammerSwipe)
    hammerManager.on("swipe", onStageSwipe)
  }
}